import React from 'react';

// Libs
import { useNavigate } from 'react-router-dom';

// Hooks
import useIsMobile from '../../../Hooks/useIsMobile';

// Components
import CardHelp from '../../Molecules/Cards/CardHelp/CardHelp';

// Constants n' Resources
import icon_help__01 from "../../../Resources/Images/HomeOut/icon_card_help_01.svg";
import icon_help__02 from "../../../Resources/Images/HomeOut/icon_card_help_02.svg";
import icon_help__03 from "../../../Resources/Images/HomeOut/icon_card_help_03.svg";

function PageHomeOutHelp() {
    const isMobile = useIsMobile();
    const navigate = useNavigate();

    return (
        isMobile && (
            <div className='text-center pb-5 my-5 px-4 fontCIBFont'>
                <div className="font24px banistmo-black">
                    ¿Necesitas ayuda?
                </div>
                <div className="fontOpenSans font16px banistmo-black-variant my-3">
                    Recibe una consultoría completa sobre<br/>tu portafolio de servicios.
                </div>
                <CardHelp
                    icono__card__help={icon_help__01}
                    titulo__card__help={'Resuelve tus dudas'}
                    texto__card__help={<div onClick={() => navigate('/centro-de-ayuda', { state: { source: 'homeOut'} })} className='text-decoration-underline'>Preguntas frecuentes</div>}
                    class__link__card__help={'d-none'}
                    class__text__card__help={'texto__card__help'}
                />
                <CardHelp
                    icono__card__help={icon_help__02}
                    titulo__card__help={'Llama a nuestras lineas de atención'}
                    texto__card__help={<a href={`tel:+5078339009`} className='text-decoration-none banistmo-black'>(507) 833-9009</a>}
                    class__link__card__help={'d-none'}
                    class__text__card__help={'texto__card__help'}
                />
                <CardHelp
                    icono__card__help={icon_help__03}
                    titulo__card__help={'Escríbenos un correo'}
                    texto__card__help={<a href={`mailto:comunicaciones@cuentacontuseguro.com`} className='text-decoration-none banistmo-black'>comunicaciones@cuentacontuseguro.com</a>}
                    class__link__card__help={'d-none'}
                    class__text__card__help={'texto__card__help'}
                />
            </div>
        )
    )
}

export default PageHomeOutHelp;